import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingButtonComponent } from 'src/app/shared/component/loading-button/loading-button.component';
import { ToastService } from 'src/app/shared/service/toast.service';
import { MESSAGES } from 'src/app/core/constant/messages';
import { UserService } from 'src/app/api/services';
import { BaseFormComponent } from 'src/app/shared/form/base-form.component';
import { TokenStorageService } from 'src/app/shared/service/token-storage.service';
import { AuthData } from 'src/app/shared/model/session';
import { concatMap, finalize } from 'rxjs';

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    LoadingButtonComponent,
    CommonModule,
  ],
  templateUrl: './confirmation.component.html',
})
export class ConfirmationComponent extends BaseFormComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  codigoConfirmado: boolean = false;
  email: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    toastService: ToastService
  ) {
    super(toastService);

    this.form = this.fb.group({
      code: this.fb.array([
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ]),
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ]),
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ]),
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ]),
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ]),
        this.fb.control('', [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9]$/),
        ]),
      ]),
    });
  }

  ngOnInit(): void {
    this.email = localStorage.getItem('emailCodijobsRegister') ?? '';
  }

  get codeControls(): FormControl[] {
    return (this.form.get('code') as FormArray).controls as FormControl[];
  }

  onInput(event: any, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value && index < 5) {
      document.getElementById(`code-${index + 1}`)?.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !input.value && index > 0) {
      document.getElementById(`code-${index - 1}`)?.focus();
    }
  }

  onSubmit(): void {
    if (!this.validateForm(this.form)) return;

    this.loading = true;
    const code = this.form.value.code?.join('');

    if (!this.email) {
      this.toastService.showMessages('error', [
        'No se encontró el correo de registro. Intenta registrarte nuevamente.',
      ]);
      this.loading = false;
      return;
    }

    this.userService
      .verifyCode(this.email, code)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res) => {
          this.codigoConfirmado = true;
          localStorage.removeItem('emailCodijobsRegister');
          this.toastService.showMessages('success', [
            'Cuenta verificada correctamente, puedes iniciar sesión ahora',
          ]);
          this.router.navigate(['login']);
        },
        error: (err) => {
          const mensajes = err?.error?.listMessage?.length
            ? err.error.listMessage
            : ['Código de verificación incorrecto'];
          this.toastService.showMessages('error', mensajes);
        },
      });
  }

  goToHome() {
    this.router.navigate(['/']);
  }
}
